import { useRef, useState, useEffect, useMemo } from "react";
const differs = (d1, d2, threshold = 50) => {
  if (!d1 || !d2)
    return !1;
  const xDiffers = Math.abs((d1.x ?? 0) - (d2.x ?? 0)) > threshold, yDiffers = Math.abs((d1.y ?? 0) - (d2.y ?? 0)) > threshold;
  return xDiffers || yDiffers;
}, useAutoHideWhenMoved = (disabled) => {
  const ref = useRef(), refTimer = useRef(null), [closed, setClosed] = useState(void 0), refDisabled = useRef(disabled);
  return refDisabled.current = disabled, useEffect(() => {
    if (disabled) return;
    const tmt = setTimeout(() => {
      closed === !0 && setClosed(void 0);
    }, 300);
    return () => clearTimeout(tmt);
  }, [closed, disabled]), useEffect(() => () => clearInterval(refTimer.current ?? void 0), []), {
    ...useMemo(() => {
      const close = () => {
        clearInterval(refTimer.current ?? void 0), setClosed(!0);
      };
      return {
        onOpen: () => {
          if (refDisabled.current) return;
          let saved = null;
          const hadChanged = (data) => {
            differs(data, saved) ? close() : saved || (saved = data);
          };
          refTimer.current = setInterval(() => {
            var _a;
            const rect = ((_a = ref.current) == null ? void 0 : _a.getBoundingClientRect()) ?? {
              x: void 0,
              y: void 0
            };
            hadChanged({ x: rect.x, y: rect.y });
          }, 100);
        },
        onClose: () => {
          clearInterval(refTimer.current ?? void 0);
        }
      };
    }, []),
    ref,
    opened: closed === !0 ? !1 : void 0
  };
};
export {
  useAutoHideWhenMoved
};
//# sourceMappingURL=useAutoHideWhenMoved.js.map
